

 export default function  Header(){

    return(
   <div>
            <h1 className="text-white text-center mt-16  text-[1.5rem]">قائمة المهام</h1>
            
        </div>
        
    )

 }